import {useTranslation} from 'react-i18next';

import RestartAltIcon from '@mui/icons-material/RestartAlt';
import {Box, Button, Typography} from '@mui/material';

import {greenColors, orangeColors} from '../../../../../layouts/theme/designSystem';

export interface Props {
  matchedCount: number;
  filterCount: number;
  isFetching: boolean;
  onClear: () => void;
}

export const WorkforceProfilesListFilterBanner = ({
  matchedCount,
  filterCount,
  isFetching,
  onClear,
}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'workforceProfilesPage.list.filter'});

  const bannerText = isFetching
    ? t('bannerLoading', {matched: matchedCount, total: filterCount})
    : t('banner', {matched: matchedCount, total: filterCount});

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: {xs: 'flex-start', sm: 'center'},
        justifyContent: 'space-between',
        gap: 1.5,
        flexWrap: 'wrap',
        mb: 2,
        px: 1.75,
        py: 1.25,
        borderRadius: '10px',
        border: `1px solid ${orangeColors[3]}`,
        bgcolor: orangeColors[5],
      }}
    >
      <Typography variant='body2' sx={{color: 'text.secondary', fontSize: '13px'}}>
        {bannerText}
      </Typography>

      <Button
        type='button'
        variant='outlined'
        size='small'
        startIcon={<RestartAltIcon fontSize='small' />}
        onClick={onClear}
        sx={{
          textTransform: 'none',
          borderColor: greenColors[700],
          color: 'text.primary',
          whiteSpace: 'nowrap',
        }}
      >
        {t('clear')}
      </Button>
    </Box>
  );
};
